import React, { useEffect, useRef } from 'react';

import heroVehicleAvif from '../../../../../../../../client/assets_seller/motchecker/checker-hero.avif';
import heroVehiclePng from '../../../../../../../../client/assets_seller/motchecker/checker-hero.png';
import heroVehicleWebp from '../../../../../../../../client/assets_seller/motchecker/checker-hero.webp';

import styles from './HeroVehicleImage.scss';

type HeroVehicleImageProps = {
  setImageLoaded: (loaded: boolean) => void;
};

export const HeroVehicleImage = ({ setImageLoaded }: HeroVehicleImageProps) => {
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const imageLoadComplete = imgRef.current?.complete;

    if (imageLoadComplete) {
      setImageLoaded(true);
    }
  }, [setImageLoaded]);

  return (
    <picture className={styles.vehicleImage}>
      <source srcSet={heroVehicleAvif} type="image/avif" />
      <source srcSet={heroVehicleWebp} type="image/webp" />
      <img
        ref={imgRef}
        alt="Vehicle"
        fetchPriority='high'
        height="614"
        onLoad={() => setImageLoaded(true)}
        src={heroVehiclePng}
        width="1682"
      />
    </picture>
  );
};
